import React from "react"
import { get } from "lodash"
import styled from "@emotion/styled"
import tw from "twin.macro"
import RichText from "./RichText"

const Grid = styled.div`
  ${tw`flex flex-wrap -ml-12 -mt-6`}
`

const Column = styled.div`
  ${tw`pl-12 mt-6 w-full md:w-1/2`}
`

const TwoColumnLayout = ({ block, alignText, contrastText }) => {
  const columnOneText = get(block, "elements.column_one.value")
  const columnOneLinkedItems = get(block, "elements.column_one.modular_content")
  const columnOneLinks = get(block, "elements.column_one.links")
  const columnTwoText = get(block, "elements.column_two.value")
  const columnTwoLinkedItems = get(block, "elements.column_two.modular_content")
  const columnTwoLinks = get(block, "elements.column_two.links")

  return (
    <Grid>
      <Column>
        <RichText
          linkedItems={columnOneLinkedItems}
          links={columnOneLinks}
          alignText={alignText}
          contrastText={contrastText}
        >
          {columnOneText}
        </RichText>
      </Column>
      <Column>
        <RichText
          linkedItems={columnTwoLinkedItems}
          links={columnTwoLinks}
          alignText={alignText}
          contrastText={contrastText}
        >
          {columnTwoText}
        </RichText>
      </Column>
    </Grid>
  )
}

export default TwoColumnLayout
